import { render, staticRenderFns } from "./WidgetDocumentInformations.vue?vue&type=template&id=7ba1b7c8&scoped=true&"
import script from "./WidgetDocumentInformations.vue?vue&type=script&lang=js&"
export * from "./WidgetDocumentInformations.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDocumentInformations.vue?vue&type=style&index=0&id=7ba1b7c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba1b7c8",
  null
  
)

export default component.exports